import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import ImagePicker from "@/components/composer/ImagePicker";

export default function TopicDialog({ topic, onClose, onSave }) {
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  const [imageId, setImageId] = useState(null);

  useEffect(() => {
    if (topic) { setTitle(topic.title || ""); setDetails(topic.details || ""); setImageId(topic.image_id || null); }
  }, [topic]);

  const submit = (e) => {
    e.preventDefault();
    onSave({ ...topic, title, details, image_id: imageId });
  };

  return (
    <Dialog open={!!topic} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="border-border bg-card sm:max-w-lg" data-testid="autopilot-topic-dialog">
        <DialogHeader>
          <DialogTitle>{topic?.id ? "Edit topik" : "Topik / produk baharu"}</DialogTitle>
          <DialogDescription>AI akan tulis post berbeza untuk setiap group berdasarkan maklumat ini.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2"><Label>Nama produk / topik</Label><Input required maxLength={120} value={title} onChange={(e) => setTitle(e.target.value)} placeholder="cth: Kek Lapis Sarawak" data-testid="autopilot-topic-title-input" /></div>
          <div className="space-y-2"><Label>Maklumat penting</Label><Textarea required minLength={3} rows={6} value={details} onChange={(e) => setDetails(e.target.value)} placeholder="Harga, kelebihan, kawasan hantar, nombor WhatsApp, pautan..." data-testid="autopilot-topic-details-input" /></div>
          <ImagePicker imageId={imageId} setImageId={setImageId} />
          <Button type="submit" className="w-full" data-testid="autopilot-topic-save-btn">Simpan topik</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
